<template>
  <div class="select2 flexRow">
    <el-select
      v-model="value"
      filterable
      :filter-method="search"
      :placeholder="control.hint ? control.hint : '请选择'"
      :multiple="!control.oneFlag"
      :disabled="disabled"
      :loading="searchLoading"
      :popper-append-to-body="false"
      :reserve-keyword="true"
      @change="selectChange"
    >
      <el-option
        v-for="item in list"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>
    <el-tooltip effect="dark" placement="bottom">
      <div slot="content">
        需先输入搜索内容后，再选择
      </div>
      <span
        style="margin-left: 6px;margin-right: 6px;font-size: 20px;color: #bdbdbd;cursor: pointer;"
      >
        <i class="el-icon-question"></i>
      </span>
    </el-tooltip>
  </div>
</template>

<script>
import { getSelect2Data } from "@/api/sheet/sheetData"
import { hasOwnProperty } from "@/utils/common"
export default {
  name: "select2",
  props: {
    initialed: Boolean,
    control: Object,
    savedValue: {
      type: Array,
      default: () => []
    },
    sheetId: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: "",
      searchText: "",
      searchLoading: false,
      list: []
    }
  },
  watch: {
    initialed: {
      handler(newVal) {
        // 父组件请求完毕后初始化
        if (newVal) this.initial()
      },
      immediate: true
    }
  },
  methods: {
    // 初始化 value
    initial() {
      if (this.savedValue && this.savedValue.length > 0) {
        if (this.control.oneFlag) this.value = this.savedValue[0].id
        else this.value = this.savedValue.map(i => i.id)
        if (this.list.length == 0) this.list = this.savedValue
      } else {
        if (this.control.oneFlag) this.value = ""
        else this.value = []
      }
    },
    // 选中项变化
    selectChange(selectedVal) {
      let data
      if (this.control.oneFlag) {
        data = this.list.find(i => i.id == selectedVal)
        data = [data]
      } else {
        data = this.list.reduce((acc, cur) => {
          if (selectedVal.includes(cur.id)) acc.push(cur)
          return acc
        }, [])
      }
      this.emitValue(data)
    },
    // 输出结果
    emitValue(value) {
      this.$emit("update:savedValue", value)
      if (hasOwnProperty(this.$listeners, "change")) this.$emit("change", value)
    },
    // 搜索
    search(searchText) {
      if (!searchText) return
      this.searchText = searchText
      this.searchLoading = true
      this.getData().then(() => (this.searchLoading = false))
    },
    // 请求数据
    getData() {
      return getSelect2Data(this.sheetId, this.control._cid, this.searchText).then(res => {
        if (res.code == 0) {
          let data = res.data
          let selected = this.savedValue.map(i => i.id)
          let union = []
          res.data.forEach(i => {
            if (!selected.includes(i.id)) union.push(i)
          })
          union = this.savedValue.concat(union)
          this.list = union
        } else {
          this.$messgae.error(res.msg || "搜索出错，请重试！")
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
